export default "__VITE_ASSET__BTWN3WaG__"